"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var __1 = require("../../../..");
var TopBarIconButton_1 = __importDefault(require("../TopBarIconButton/TopBarIconButton"));
var icons_1 = require("../../../../../icons");
var AppSwitcher_1 = __importDefault(require("../../../AppSwitcher/AppSwitcher"));
var TopBarAppSwitcher = function () { return (react_1.jsx(__1.Dropdown, { menu: react_1.jsx(AppSwitcher_1.default, null) },
    react_1.jsx(TopBarIconButton_1.default, { icon: icons_1.DotsGrid, "data-6si-name": "top-bar--app-switcher-button" }))); };
TopBarAppSwitcher.displayName = 'TopBar.AppSwitcher';
exports.default = TopBarAppSwitcher;
